import { AppCard, AppCardContent, AppCardTitle } from '@app/components/base/app-card';
import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import { ReactNode, useContext } from 'react';
import { FragmentGridContext } from '../../fragments-grid/FragmentGridContext';
import { buildFragmentNavigationParams } from './fragment-navigation';
import { FragmentCardFooter } from './FragmentCardFooter';
import { fragmentGridCardContentSx } from './styles';

/**
 * Shared card wrapper for fragment cards: layout and click navigation to fragment view.
 * Uses AppCard with internal router Link so the card is a real link (Ctrl/Cmd+click opens in new tab).
 * Renders optional media (e.g. poster), then body content, then footer.
 */
export function FragmentCardBase({
  fragment,
  media,
  content,
}: {
  fragment: FragmentListItemDto;
  /** Optional media area (e.g. poster for video cards). */
  media?: ReactNode;
  /** Main content rendered inside the card body. */
  content?: ReactNode;
}) {
  const to = buildFragmentNavigationParams(fragment);
  const isCompact = useContext(FragmentGridContext)?.viewMode === 'gridCompact';

  return (
    <AppCard to={to} media={media} footer={<FragmentCardFooter fragment={fragment} />}>
      <AppCardContent sx={fragmentGridCardContentSx}>
        {content ?? (
          <AppCardTitle title={fragment.title} variant={isCompact ? 'body2' : 'subtitle1'} />
        )}
      </AppCardContent>
    </AppCard>
  );
}
